import React from "react";
import {
  Box,
  Flex,
  Checkbox,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { IconArrowDown } from "components/icons/Icons";

interface DocumentStatusControlsProps {
  isApplyAll: boolean;
  setIsApplyAll: (value: boolean) => void;
  allDocumentStatus: { id: number; label: string };
  setAllDocumentStatus: (status: { id: number; label: string }) => void;
  documentStatus: Array<{ id: number; label: string }>;
  isUpdatingProjectStatus: boolean;
  onClickUpdateDocumentsStatus: () => void;
}

export const DocumentStatusControls: React.FC<DocumentStatusControlsProps> = ({
  isApplyAll,
  setIsApplyAll,
  allDocumentStatus,
  setAllDocumentStatus,
  documentStatus,
  isUpdatingProjectStatus,
  onClickUpdateDocumentsStatus,
}) => {
  const shadow = useColorModeValue(
    "0px 4px 50px rgba(0, 0, 0, 0.1)",
    "0px 4px 50px rgba(0, 0, 0, 0.1)"
  );

  return (
    <Box p={3}>
      <Flex alignItems="center" columnGap="10px" flexWrap="wrap" rowGap="20px">
        <Checkbox
          mr="5"
          sx={{
            ".chakra-checkbox__control": {
              borderColor: "#2F80ED",
            },
          }}
          onChange={(e: any) => setIsApplyAll(e.target.checked)}
        >
          Update all documents' status
        </Checkbox>
        {isApplyAll && (
          <Flex flex="1">
            <Menu>
              <MenuButton
                padding={"10px 10px 10px 15px"}
                backgroundColor="#F3F5F5"
                borderRadius="10px"
              >
                <Flex alignItems={"center"}>
                  <Text
                    fontSize={"14px"}
                    lineHeight="24px"
                    fontWeight={"400"}
                    color="black"
                  >
                    {allDocumentStatus.label}
                  </Text>
                  <IconBox
                    marginLeft="10px"
                    icon={<IconArrowDown width="24px" height="24px" />}
                  ></IconBox>
                </Flex>
              </MenuButton>
              <MenuList
                boxShadow={shadow}
                p="0px"
                mt="10px"
                borderRadius="20px"
                bg={"#FFF"}
                border="none"
              >
                <Flex
                  flexDirection="column"
                  p="10px 20px"
                  fontSize={"14px"}
                  lineHeight="24px"
                  fontWeight={"400"}
                  color="black"
                >
                  {documentStatus.map((option, index: number) => (
                    <MenuItem
                      key={index}
                      _hover={{ bg: "none" }}
                      _focus={{ bg: "none" }}
                      borderRadius="8px"
                      padding="15px 0px"
                      onClick={() => {
                        setAllDocumentStatus(option);
                      }}
                      borderBottom="1px solid #F3F5F5"
                    >
                      <Text fontSize="sm">{option.label}</Text>
                    </MenuItem>
                  ))}
                </Flex>
              </MenuList>
            </Menu>
            <Button
              padding="10px 20px"
              border={"2px solid #2F80FD"}
              borderRadius="100px"
              fontSize="14px"
              lineHeight="24px"
              fontWeight="400"
              color="#2F80FD"
              bg="#FFF"
              ml="auto"
              disabled={isUpdatingProjectStatus}
              isLoading={isUpdatingProjectStatus}
              onClick={onClickUpdateDocumentsStatus}
            >
              Save Changes
            </Button>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};
